import { getVizColors } from '@opengov/capital-style/';
export var demoColorPalette = getVizColors(20);
export var options = demoColorPalette.map(function (option) {
  return {
    label: option.base,
    color: option.base,
    hoverColor: option.highlight
  };
});